import React from 'react';
import { Logo } from '@americanexpress/dls-react';

const Footer = () => (
  <footer
    className="nav nav-horizontal border nav-chevron nav-footer"
    style={{ zIndex: '-1' }}
    data-toggle="nav"
    data-responsive="md"
  >
    <hr />
    <div className="stack-3 pad-2-lr pad-3-t pad-4-b">
      <div className="row">
        <div className="col-md-6">
          <Logo styleType="line" size="sm" alt="American Express" className="displayBlock" />
        </div>
      </div>
      <div className="stack">
        <p>&#169; {new Date().getFullYear()} American Express Company. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
